import { render, staticRenderFns } from "./microphone.vue?vue&type=template&id=2d0de032&scoped=true"
import script from "./microphone.vue?vue&type=script&lang=js"
export * from "./microphone.vue?vue&type=script&lang=js"
import style0 from "./microphone.vue?vue&type=style&index=0&id=2d0de032&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0de032",
  null
  
)

export default component.exports